import { type InputHTMLAttributes, forwardRef } from "react";
import type { RegisterOptions } from "react-hook-form";
import cx from "classnames";

import { Input, type InputProps } from "@/components/ui/input";
import { InputWrapper, InputWrapperProps } from "./InputWrapper";

type TextFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> &
  Omit<InputWrapperProps, "children"> & {
    validate?: RegisterOptions["validate"];
  } & InputProps;

export const TextField = forwardRef<HTMLInputElement | null, TextFieldProps>(
  (
    {
      label,
      name,
      required,
      pattern,
      validate,
      className,
      wrapperClassName,
      ...rest
    },
    ref
  ) => (
    <InputWrapper name={name} label={label} wrapperClassName={wrapperClassName}>
      {(register, errors) => (
        <>
          <Input
            ref={ref}
            id={name}
            name={register === null ? name : undefined}
            className={cx(
              {
                "border-red-500": errors && !!errors[name],
              },
              className
            )}
            {...(!!name &&
              register !== null &&
              register(name, {
                validate,
                required,
                pattern: pattern as RegisterOptions["pattern"],
              }))}
            {...rest}
          />
          {errors && errors[name]?.type === "pattern" && (
            <p className="font-semibold text-red-700 text-sm">
              The value provided doesn't match the required pattern.
            </p>
          )}
          {errors && errors[name]?.type === "required" && (
            <p className="font-semibold text-red-700 text-sm">
              Please provide a value.
            </p>
          )}
          {errors &&
            (errors[name]?.type === "equality" ||
              errors[name]?.type === "validate") && (
              <p className="font-semibold text-red-700 text-sm">
                {errors[name]?.message}
              </p>
            )}
        </>
      )}
    </InputWrapper>
  )
);
